// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDuqTtJw57d5n1RjlHQs5OANr5lImOomgg",
    authDomain: "tradecrypto-8b55f.firebaseapp.com",
    projectId: "tradecrypto-8b55f",
    storageBucket: "tradecrypto-8b55f.appspot.com",
    messagingSenderId: "42809773893",
    appId: "1:42809773893:web:2c07cddedfb4328580b82c",
    measurementId: "G-J2QQ0Y7M4D" //
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
